import _ from 'lodash'
import {
  parseDate
} from '@/assets/func'

export default {
  getSearchList: (state) => {   // --> use --> resultList
    let num = state.currentPage

    return viewCnt => {
      let arr = []
      let sIndex = (num - 1) * viewCnt
      let eIndex = sIndex + viewCnt

      for (let i = sIndex; i < eIndex; i++) {
        if (state.searchList.data[i] !== undefined) {
          arr.push(state.searchList.data[i])
        }
      }

      let res = {
        data: arr,
        info: state.searchList.info
      }
      return res
    }
  },
  chartDatas: (state, getters) => {
    const data = state.campaign.contractData
    const contractLength = data.contract.length
    const isInterplay = (() => {
      let camName = state.campaign.campaignInfo.campaign_nm
      return camName === undefined ? false : (camName.indexOf('인터플레이') > -1 ? true : camName.indexOf('PIP') > -1)
    })()
    const isMul = () => {
      return contractLength > 1
    }
    const names = isMul ? ['', ..._.map(data.contract, function (o) { return o.ad_knd_nm + ' ' + o.dp_knd_nm })]
      : _.map(data.contract, function (o) { return o.ad_knd_nm + ' ' + o.dp_knd_nm })
    // chart 이름 추출
    const getChartNames = () => {
      let data = [...names]
      let res = []
      res[0] = '전체 노출 및 클릭률'
      for (let i = 1; i < data.length; i++) {
        let temp = data[i].split(' ')
        temp = temp[0] + '(' + temp[1] + ')'
        res.push(temp)
      }

      return [...res]
    }
    // ctr, vtr 평균값 추출
    const getAvgData = () => {
      let data = [...state.campaign.contractData.contract]
      let res = []
      let totAvg = {}
      let totClick = 0
      let totView = 0
      let totImp = 0

      for (let i = 0; i < data.length; i++) {
        totClick += data[i].click_cnt
        totImp += data[i].imp_cnt
        if (isInterplay) {
          totView += data[i].view_cnt
        }

        let idx = names.indexOf(data[i].ad_knd_nm + ' ' + data[i].dp_knd_nm)
        let avg = {}
        avg.ctr = data[i].ctr + ''
        if (isInterplay) {
          avg.vtr = (data[i].vtr).toFixed(1)
        }
        res[idx] = avg
      }

      let temp = totClick / totImp * 100
      totAvg.ctr = (isNaN(temp) ? 0 : temp).toFixed(2)
      if (isInterplay) {
        temp = totView / totImp * 100
        totAvg.vtr = (isNaN(temp) ? 0 : temp).toFixed(1)
      }

      res[0] = totAvg

      return [...res]
    }
    // chart 그리는 데이터 추출
    const getChartData = () => {
      const daysDataList = getters.daysImpData('contract', false)
      let res = []

      for (let i = 0; i <= (isMul ? contractLength : contractLength - 1); i++) {
        res[i] = []
      }

      for (let i = 0; i < daysDataList.length; i++) {
        let date = parseDate(daysDataList[i].ymd)
        let today = new Date()
        let isEqual = (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate())
        // 오늘 날짜가 되면 리턴 (데이터는 어제 날짜 까지)
        if (isEqual) break

        /* 합계 데이터 추가 */
        let obj = {
          ymd: daysDataList[i].ymd,
          imp_cnt: daysDataList[i].imp,
          ctr: daysDataList[i].ctr
        }
        if (isInterplay) {
          obj.view_cnt = daysDataList[i].view
          obj.vtr = daysDataList[i].vtr
          obj.end_rate = 0 // 안나오는게 맞음
        }
        res[0].push(obj)

        /* 상품별 데이터 추가 */
        // 데이터가 전부 있으면
        // 홀딩일 때는 contractLength만으로 비교할 수 없다. 날짜별로 null 데이터가 넘어오니까. 19.05.07 추가
        if ((daysDataList[i].data.length === contractLength) && (daysDataList[i].data.ymd && daysDataList[i].data.imp_cnt && daysDataList[i].data.ctr)) {
          daysDataList[i].data.forEach((data) => {
            let idx = names.indexOf(data.ad_knd_nm + ' ' + data.dp_knd_nm)
            let d = {
              ymd: data.ymd,
              imp_cnt: data.imp_cnt,
              ctr: data.ctr
            }
            if (isInterplay) {
              d.view_cnt = data.view_cnt
              d.vtr = data.vtr
              d.end_rate = (data.end_rate).toFixed(2) * 1
            }
            // if (d.imp_cnt && d.ctr) res[idx].push(d)
            res[idx].push(d)
          })
        } else {
          // 데이터가 일부만 있거나 없을 경우
          let temp = [...daysDataList[i].data]
          let idx = 0
          // 있는 데이터 추가
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].ad_knd_nm !== null) {
              idx = names.indexOf(temp[i].ad_knd_nm + ' ' + temp[i].dp_knd_nm)
              let d = {
                ymd: temp[i].ymd,
                imp_cnt: temp[i].imp_cnt,
                ctr: temp[i].ctr
              }

              if (isInterplay) {
                d.view_cnt = temp[i].view_cnt
                d.vtr = temp[i].vtr
                d.end_rate = temp[i].end_rate
              }
              res[idx].push(d)
            }
          }
          // 빈 데이터 추가
          for (let i = 1; i < res.length; i++) {
            if (res[0].length !== res[i].length) {
              let obj = {
                ymd: temp[0].ymd,
                imp_cnt: 0,
                ctr: 0
              }
              if (isInterplay) {
                obj.viewcnt = 0
                obj.vtr = 0
                obj.end_rate = 0
              }
              res[i].push(obj)
            }
          }
        }
      }

      return [...res]
    }

    let res = {
      chartData: [],
      chartNames: [],
      avgData: []
    }

    res.chartData = getChartData()
    res.chartNames = getChartNames()
    res.avgData = getAvgData()
    return res
  }
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js